function normalizeList(values) {
  if (Array.isArray(values)) return values;
  if (typeof values === 'string') return values.split(',');
  return [];
}

function uniq(values) {
  return [...new Set(values)];
}

export function sanitizeSparseFieldset(values) {
  return uniq(
    normalizeList(values)
      .map(value => (typeof value === 'string' ? value.trim() : ''))
      .filter(Boolean)
      .filter(value => !value.includes('.'))
  );
}

export function sanitizeInclude(values) {
  return uniq(
    normalizeList(values)
      .map(value => (typeof value === 'string' ? value.trim() : ''))
      .filter(Boolean)
  );
}

export function serializeSparseFieldset(values) {
  return sanitizeSparseFieldset(values).join(',');
}

export function serializeInclude(values) {
  return sanitizeInclude(values).join(',');
}

export function sanitizeSparseFieldsets(fieldsets = {}) {
  return Object.entries(fieldsets).reduce((acc, [type, values]) => {
    acc[type] = serializeSparseFieldset(values);
    return acc;
  }, {});
}

export function appendSparseFields(currentValue, valuesToAppend) {
  return serializeSparseFieldset([
    ...sanitizeSparseFieldset(currentValue),
    ...sanitizeSparseFieldset(valuesToAppend),
  ]);
}
